class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.headerSearch = this.closest('.header-search');
    this.searchFilterModal = document.querySelector('.search-filter-modal');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.MainPredictiveSearchResults =
      this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.searchHistory = 'searchHistory';

    this.setupEventListeners();

    // Initialize Search Tags Slider
    this.initializeSearchTagsSlider();

    // Bind Search Tags to Input
    this.bindSearchFilterToInput();
    this.initSearchIconPress();

    this.onScentFamiliesClick();
    this.onAIneeClick();
    this.initSuggestionsLogic();

    this.updatePDPlink();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.addEventListener('input', this.onInput.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange(e) {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      // this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    console.log('@__> din onchange');

    //check if new search differs from old
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    const oldSearchValue = params.get("q");

    if (this.searchTerm != oldSearchValue) {
      console.log('@--> differente params')

      if (e.detail.source == 'search_button_filters') {
        window.location.href = `/search?q=${this.searchTerm}`
      }
      if (e.detail.source == 'search_gender_filters') {
        window.location.href = `/search?q=${this.searchTerm}`
      }
      else {
        if (!window.location.href.includes('/search')) {
          if (this.searchTerm <= 3) {
            console.log('show suggestion')
          }
          else {
            this.getSearchResults(this.searchTerm);
          }
        } else {
          if (this.searchTerm <= 3) {
            console.log('show suggestion')
          }
          else {
            this.getSearchResults(this.searchTerm);
          }
        }

        if (this.id == 'predictive-search__header') {
          console.log('@--->>>>> bold and hide things')
          if (this.searchTerm.length <= 4) {
            this.filterButtonFilters();
          }
        }
      }

    }
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    console.log("@->>> din on focus")
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
    }
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown' || event.key === "Enter") {
      event.preventDefault();

      if (event.key === "Enter" && event.target.value.length >= 3) {

        console.log('ENTER pressed go to search page')

        const inputValue = event.target.value;
        console.log('search term', inputValue)


        if (window.location.href.includes('/search')) {
          // do rerendering search
          console.log('@---------> 0: do rerendering on search page')
          this.getSearchResults(inputValue);
        }
        else {
          // do rerouting search
          window.location.href = `/search?q=${inputValue}` //add locale param
        }
      }
    }
  }

  initSearchIconPress() {
    const searchIconButton = this.querySelector('.search__button');
    // console.log('search button', searchIconButton)
    searchIconButton.addEventListener('click', (e) => {
      e.preventDefault();
      const inputValue = this.input.value;
      if (inputValue.length == 0) {
        return
      }

      if (window.location.href.includes('/search')) {
        // do rerendering search
        this.getSearchResults(inputValue);
      }
      else {
        // do rerouting search
        window.location.href = `/search?q=${inputValue}` //add locale param
      }
    })
  }

  onInput() {
    if (this.classList.contains('search_suggestion_selected')) {
      this.classList.remove('search_suggestion_selected');
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {

    console.log('@--> 1: din serach results', searchTerm)

    const queryKey = searchTerm.replace(' ', '-').toLowerCase();

    if (window.location.href.includes('/search')) {
      // update url
      const url = new URL(window.location);
      url.searchParams.set("q", searchTerm);
      window.history.pushState({}, "", url);
      // update input value
      this.input.value = searchTerm;
    }

    if (this.id == 'predictive-search_main') {
      this.setLiveRegionLoadingState();
    }


    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[limit]=20&resources[options][fields]=title,product_type,tag,vendor&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });


        console.log('@--> 2: afetr fetch rerendeding APi')

        if (!window.location.href.includes('/search')) {
          if (this.id == 'predictive-search__header') {
            //show only suggestions

            const resultsSuggestionsMarkup = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('#shopify-section-predictive-search .predictive-search__suggestions')?.innerHTML;

            console.log('show sugestions');

            if (resultsSuggestionsMarkup) {
              this.renderSearchResults(resultsSuggestionsMarkup);
            }
          }
        }
        else {
          if (this.id == 'predictive-search__header') {
            console.log('close modal and show results in main search');
            document.body.classList.remove('overflow-hidden');
            document.querySelector('.header__search details').removeAttribute('open');
            document.querySelector('#predictive-search_main').renderSearchResults(resultsMarkup);
            document.querySelector('#predictive-search_main').input.value = searchTerm;
          }
          else if (this.id == 'predictive-search_main') {
            this.renderSearchResults(resultsMarkup);
          }
        }
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    if (this.statusElement) {
      this.statusElement.setAttribute('aria-hidden', 'false');
      this.statusElement.textContent = statusText;

      setTimeout(() => {
        this.statusElement.setAttribute('aria-hidden', 'true');
      }, 1000);
    }
  }

  renderSearchResults(resultsMarkup) {
    const results = document.createElement('div');
    results.innerHTML = resultsMarkup;
    results.classList.add('predictive-search--container');

    // search 3.0
    if (this.id == 'predictive-search__header') {

      console.log('@--> 2 show sugestions');
      results.classList.add('predictive-search-header__suggestions');
      this.classList.add('suggestions-shown');
      this.querySelector('.predictive-search--container')?.remove();
      this.appendChild(results);
    }
    else if (this.id == 'predictive-search_main') {
      console.log('@--> din main search ')

      console.log('@--> 5 din render search results')
      const resultsEl = this.querySelector('#search-results');
      console.log('results el', resultsEl)
      resultsEl.innerHTML = '';
      this.setAttribute('results', true);
      resultsEl.appendChild(results);
      const landing = document.querySelector('.main-search-page .main-search__landing');
      if (landing) landing.hidden = true;
      this.setLiveRegionResults();
      initializeCustomTabs();
      if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets === 'function') {
        yotpoWidgetsContainer.initWidgets();
      }
      showDynamicPrices();


      this.updatePDPlink();
    }

  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom - 20;
    if (window.innerWidth < 768) {
      this.resultsMaxHeight = window.innerHeight - 20;
    }
    return this.resultsMaxHeight;
  }

  open() {
    // this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;

    if (this.headerSearch) this.searchFilterModal.style.display = 'none' // Hide search landing popup
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
    this.classList.remove('suggestions-shown');

    if (this.headerSearch) this.searchFilterModal.style.display = 'block' // Show search landing popup
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    // this.predictiveSearchResults.removeAttribute('style');
  }

  initializeSearchTagsSlider() {
    const searchFiltersSliders = document.querySelectorAll('.search-filters__slider');

    searchFiltersSliders.forEach((slider) => {
      this.setupSearchTagsSlider(slider);
    });
  }

  setupSearchTagsSlider(slider) {
    const sliderContainer = slider.querySelector('.slider-container');
    const sliderList = slider.querySelector('.search-filters__list');
    const sliderItem = sliderContainer.querySelector('.search-filters__item');

    if (sliderItem) {
      const scrollDistance = 140;

      const prevButton = slider.querySelector('.slider-prev');
      const nextButton = slider.querySelector('.slider-next');

      const updateButtonVisibility = () => {
        const maxScrollLeft = Math.ceil(sliderContainer.scrollWidth - sliderContainer.clientWidth);
        const currentScrollLeft = Math.ceil(sliderContainer.scrollLeft);

        // Hide prevButton if at the start, otherwise show it
        if (currentScrollLeft <= 0) {
          prevButton.classList.add('hidden');
          slider.classList.remove('scrollToLeft');
        } else {
          prevButton.classList.remove('hidden');
          slider.classList.add('scrollToLeft');
        }

        // Hide nextButton if at the end, otherwise show it
        if (currentScrollLeft >= maxScrollLeft || sliderList.offsetWidth < 498) {
          nextButton.classList.add('hidden');
          slider.classList.remove('scrollToRight');
        } else {
          nextButton.classList.remove('hidden');
          slider.classList.add('scrollToRight');
        }
      };

      updateButtonVisibility();

      prevButton.addEventListener('click', () => {
        sliderContainer.scrollBy({
          left: -scrollDistance,
          behavior: 'smooth'
        });
      });

      nextButton.addEventListener('click', () => {
        sliderContainer.scrollBy({
          left: scrollDistance,
          behavior: 'smooth'
        });
      });

      sliderContainer.addEventListener('scroll', updateButtonVisibility);
    }
  }

  bindSearchFilterToInput() {
    const searchFilters = document.querySelectorAll('.search-filters__list');

    searchFilters.forEach((searchFilter) => {
      searchFilter.addEventListener('click', (event) => {
        const filterItem = event.target.closest('.search-filters__item');
        if (filterItem) {
          const currentTarget = event.target;
          this.handleFilterItemClick(currentTarget);
        }
      });
    });
  }

  handleFilterItemClick(currentTarget) {
    let filterItemText = currentTarget.textContent.trim();

    if (currentTarget.dataset.searchTerm) {
      filterItemText = currentTarget.dataset.searchTerm;
    }
    if (currentTarget.dataset.originalText) {
      filterItemText = currentTarget.dataset.originalText;
    }

    const newFilterItemText = filterItemText.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');

    // Popular search / suggestion pill → go straight to the search results,
    // don't trigger the predictive suggestions dropdown for the picked term
    window.location.href = `/search?q=${encodeURIComponent(newFilterItemText)}`;
  }

  bindSearchSuggestionsToInput() {
    const searchModal = this.closest('.search-modal');

    if (searchModal) {
      const predictiveSearchSuggestions = this.querySelector('.predictive-search__suggestions');

      if (predictiveSearchSuggestions) {
        const searchSuggestions = predictiveSearchSuggestions.querySelectorAll('li a');

        if (searchSuggestions && searchSuggestions.length > 0) {
          searchSuggestions.forEach((searchSuggestion) => {
            searchSuggestion.addEventListener('click', (event) => {
              event.preventDefault();
              const currentTarget = event.currentTarget;
              const buttonLink = currentTarget.href;
              if (buttonLink.includes('/search')) {
                this.handleFilterItemClick(currentTarget);
                // Hide Search Suggestions if a tag is clicked
                if (!this.classList.contains('search_suggestion_selected')) {
                  this.classList.add('search_suggestion_selected');
                }
              } else {
                window.location.href = buttonLink;
              }
            });
          });
        }
      }
    }
  }

  // search 3.0 update

  onScentFamiliesClick() {
    // console.log('init scent families thing!!')
    const scentFamiliesContainer = document.querySelector('.search-filters_scent-families');

    if (!scentFamiliesContainer) {
      return
    }
    scentFamiliesContainer.addEventListener('click', (e) => {
      if (e.target.closest('button')) {

        let scentFamily = e.target.dataset.scentFamily;

        const capitalize = str => str && str[0].toUpperCase() + str.slice(1);
        scentFamily = capitalize(scentFamily);

        console.log('scentFamily:', scentFamily)

        window.location.href = `/search?q=${scentFamily}`;
      }
    })
  }

  onAIneeClick() {
    const AIneeContainer = document.querySelector('.search-filters_ainee');

    if (!AIneeContainer) {
      return
    }

    AIneeContainer.addEventListener('click', (e) => {
      // redirect to ainee page
      window.location.href = `/pages/perfume-assistant`
    })
  }

  initSuggestionsLogic() {
    // close sugestions when clicking anywhere else besidies it or input
    document.body.addEventListener('click', (e) => {
      // console.log('click din sugestions logic', e);
      if (e.target.closest('.search_input_field')) {
        this.classList.add('suggestions-shown');
      }
      else if (e.target.closest('.predictive-search__suggestions') || e.target.closest('.predictive-search-header__suggestions')) {
        //get new serach results based on clicked element
        const searchTerm = e.target.closest('.predictive-search__item').dataset.searchTerm;
        this.classList.remove('suggestions-shown');

        if (e.target.closest('#predictive-search__header')) {
          // console.log('facem redirect', this.id)
          window.location.href = `/search?q=${searchTerm}`;
        }
        else if (e.target.closest('#predictive-search_main')) {
          this.getSearchResults(searchTerm);
        }
      }
      else {
        this.classList.remove('suggestions-shown');
      }
    })
  }

  updatePDPlink() {
    //updates product card link so that from PDP user can return to search
    if (window.location.href.includes('/search')) {
      let links = document.querySelectorAll('#predictive-search-results-groups-wrapper a[data-link-to-product]')
      // console.log('links:', links)
      links.forEach(el => {
        if (!el.href.includes('back-to-search')) {
          el.href = `${el.href}&back-to-search=${this.input.value}`
        }
      })
    }
  }

  filterButtonFilters() {
    console.log('din filter filters')
    let brandsFilters = document.querySelectorAll('.header__search .filters__brands .search-filters__item');
    let notesFilters = document.querySelectorAll('.header__search .filters__scent-notes .search-filters__item');

    let brandsFilters_nav = document.querySelector('.header__search .filters__brands .search-filters__nav');
    let notesFilters_nav = document.querySelector('.header__search .filters__scent-notes .search-filters__nav');

    if (notesFilters && brandsFilters) {
      // console.log('filtram brands', brandsFilters)
      // console.log('filtram notes', notesFilters)

      let searchTerm = this.input.value;
      let hiddenNumber = 0;

      if (document.querySelector(".filters__brands .no-res-text")) {
        document.querySelector(".filters__brands .no-res-text").remove();
      }
      if (document.querySelector(".filters__scent-notes .no-res-text")) {
        document.querySelector(".filters__scent-notes .no-res-text").remove();
      }

      // console.log('search term', searchTerm)

      brandsFilters.forEach(el => {
        const originalText = el.dataset.originalText;

        if (!searchTerm) {
          // Reset to original when input is empty
          el.innerHTML = originalText;
          el.style.display = "";
          brandsFilters_nav.style.display = "";
          hiddenNumber = 0;
          return;
        }

        if (originalText.toLowerCase().includes(searchTerm)) {
          const regex = new RegExp(`(${searchTerm})`, "gi");
          el.innerHTML = originalText.replace(regex, "<b>$1</b>");
          el.style.display = "";
          hiddenNumber--;
          brandsFilters_nav.style.display = "none";
        } else {
          el.innerHTML = originalText;
          el.style.display = "none";
          hiddenNumber++;
        }
      });

      // check hidden
      if (hiddenNumber == brandsFilters.length) {
        console.log('show no results txt')
        brandsFilters_nav.style.display = "none";
        let noResText = document.createElement('p');
        noResText.innerHTML = `<p class="no-res-text">No impressions of inspired-by brands containing "${searchTerm}" exist..</p>`
        document.querySelector('.header__search .filters__brands').appendChild(noResText)
      }

      hiddenNumber = 0;

      notesFilters.forEach(el => {
        const originalText = el.dataset.originalText;

        if (!searchTerm) {
          // Reset to original when input is empty
          el.innerHTML = originalText;
          el.style.display = "";
          notesFilters_nav.style.display = "";
          hiddenNumber = 0
          return;
        }

        if (originalText.toLowerCase().includes(searchTerm)) {
          const regex = new RegExp(`(${searchTerm})`, "gi");
          el.innerHTML = originalText.replace(regex, "<b>$1</b>");
          el.style.display = "";
          notesFilters_nav.style.display = "none";
          hiddenNumber--
        } else {
          el.innerHTML = originalText;
          el.style.display = "none";
          hiddenNumber++;
        }
      });

      if (hiddenNumber == notesFilters.length) {
        // console.log('show no results txt')
        notesFilters_nav.style.display = "none";
        let noResText = document.createElement('p');
        noResText.innerHTML = `<p class="no-res-text">No scent notes containing "${searchTerm}" exist..</p>`
        document.querySelector('.header__search .filters__scent-notes').appendChild(noResText)
      }
    }
    else {
      return
    }
  }

  // END search 3.0 update

}

customElements.define('predictive-search', PredictiveSearch);